import 'whatwg-fetch';
import { config } from '../config';
import { auth } from './auth';

function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  }

  if (response.status >= 500 && response.status < 600) {
    if (!config.debug) {
      console.error('API error:', response);
      alert('There was an unexpected API error. Please try reloading the page or contact support.');
    }
  }

  if (response.contentType && response.contentType.indexOf('application/json') !== -1) {
    throw response;
  }
  return response
    .json()
    .catch(error => {
      console.warn("Response from API wasn't JSON serializable", error);
      return {};
    }) // We should always return with an object
    .then(body => {
      const error = {
        body,
        status: response.status,
        statusText: response.statusText,
      };
      throw error;
    });
}

function errorHandler(error) {
  if (error && error.status && error.status === 401) {
    auth.setUserToken(null);
    window.location.reload();
    return;
  }
  throw error;
}

export async function blob({ method = 'GET', endpoint, data, usingAuthToken = true }) {
  const url = `${config.apiUrl}${endpoint}`;
  const params = {
    method,
    headers: {},
    mode: 'cors',
  };

  if (usingAuthToken) {
    const token = auth.getUserToken();
    if (token) {
      params.headers.Authorization = `Token ${token}`;
    }
  }
  return fetch(url, params)
    .then(checkStatus)
    .then(resp => resp.blob())
    .catch(errorHandler);
}

export async function api({
  method = 'GET',
  endpoint,
  data,
  usingAuthToken = true,
  rawBody = false,
}) {
  const url = `${config.apiUrl}${endpoint}`;
  const params = {
    method,
    headers: {},
    mode: 'cors',
  };

  if (!rawBody) {
    params.headers['Content-Type'] = 'application/json';
  }

  if (usingAuthToken) {
    const token = auth.getUserToken();
    if (token) {
      params.headers.Authorization = `Token ${token}`;
    }
  }

  if (data) {
    params.body = rawBody ? data : JSON.stringify(data);
  }

  return fetch(url, params)
    .then(checkStatus)
    .then(
      resp =>
        resp.json().catch(error => {
          console.warn("Response from API wasn't JSON serializable", error);
          return {};
        }), // We should always return with an object)
    )
    .catch(errorHandler);
}



// WEBPACK FOOTER //
// ./src/libs/api.js